import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { RepeatIcon, LightningIcon } from '@fiverr-private/icons';
import { HourlyL1Icon } from '@fiverr-private/visuals';
import { Icon } from '@fiverr-private/fit';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { theme } from '@fiverr-private/theme';
import { ResponseTimeInfo } from '../ResponseTimeInfo';
import styles from './HighlightContent.module.scss';

const T_PREFIX = 'seller_page_perseus.professions_page.sidebar.highlights';

export enum HighlightTypes {
    LOYALTY = 'loyalty',
    RESPONSIVE = 'responsive',
    RESPONSE_TIME = 'response_time',
    HOURLY_RATES = 'HOURLY_RATES',
}

export const HighlightContent = ({ type }: { type: HighlightTypes }) => {
    switch (type) {
        case HighlightTypes.RESPONSE_TIME: {
            return <ResponseTimeInfo />;
        }
        case HighlightTypes.LOYALTY: {
            return (
                <Stack alignItems="center" gap="2">
                    <Icon color={theme.colors.grey_1200}>
                        <RepeatIcon />
                    </Icon>
                    <Text size="b_sm">
                        <I18n k={`${T_PREFIX}.loyalty`} />
                    </Text>
                </Stack>
            );
        }
        case HighlightTypes.RESPONSIVE: {
            return (
                <Stack alignItems="center" gap="2">
                    <Icon color={theme.colors.grey_1200}>
                        <LightningIcon />
                    </Icon>
                    <Text size="b_sm">
                        <I18n k={`${T_PREFIX}.responsive`} />
                    </Text>
                </Stack>
            );
        }
        case HighlightTypes.HOURLY_RATES: {
            return (
                <Stack alignItems="center" gap="2">
                    <Icon className={styles.hourlyIcon} color={theme.colors.grey_1200}>
                        <HourlyL1Icon color="grey_1200" />
                    </Icon>
                    <Text size="b_sm">
                        <I18n k={`${T_PREFIX}.hourly_rates`} />
                    </Text>
                </Stack>
            );
        }
        default: {
            return null;
        }
    }
};
